import axios from 'axios'

export function LogAccessEvent(teamID: string, hostID: string, userName: string, componentName: string) {
  axios.post('/api/teams/' + teamID + '/hosts/' + hostID + '/events/access', {
    user: userName,
    component: componentName,
  })
}
